/* eslint-disable @typescript-eslint/no-var-requires */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { DropdownSelectList } from '../../app/types';
import { DropdownDirective } from './Dropdown.directive';

@Component({
    standalone: true,
    selector: 'global-home-dropdown',
    styleUrls: ['../../styles.scss', './dropdown.component.scss'],
    templateUrl: './dropdown.component.html',
    imports: [CommonModule, IconComponent, DropdownDirective],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.ShadowDom,
})
export class DropdownComponent {
    @Input() selectList!: DropdownSelectList[];

    @Input() buttonText!: string;

    isShowingDropdown = false;

    dropdownSvg = (require('!!raw-loader?!../../assets/icons/chevron-down.svg') as { default: string }).default;

    constructor(private cdr: ChangeDetectorRef) {}

    showDropdown() {
        this.isShowingDropdown = true;
        this.cdr.detectChanges();
    }

    hideDropdown() {
        this.isShowingDropdown = false;
        this.cdr.detectChanges();
    }

    closeDropdown(): void {
        this.isShowingDropdown = false;
        this.cdr.detectChanges();
    }

    handleKeyupEvent(event: KeyboardEvent) {
        if (this.isShowingDropdown && event.key === 'Escape') {
            this.closeDropdown();
        }
    }
}
